import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AppBar } from '@material-ui/core';

const WEAppBarElement = withStyles({
  root: (attributes) => ({
    position: 'static',
    display: 'flex',
    flexDirection: attributes.flexdirection,
    color: attributes.textcolor,
    background: attributes.background,
  }),
})(AppBar);

const WEAppBar = (props) => {
  const attributes = { ...props };
  if (!attributes.textcolor) {
    attributes.textcolor = '#313131';
  }
  if (!attributes.background) {
    attributes.background = '#FFFFFF';
  }
  if (!attributes.flexdirection) {
    attributes.flexdirection = 'row';
  }
  if (!attributes.elevation) {
    attributes.elevation = 0;
  }
  const children = props.children;

  return <WEAppBarElement {...attributes}>{children}</WEAppBarElement>;
};

export default WEAppBar;
